import { useCallback, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { CashRegisterOperationsTableContext } from '../contexts';

export const useCashRegisterOperationsTableActionBar = () => {
  const { selection, selectAll, fetch, reset, resetSelection } = useContext(CashRegisterOperationsTableContext);

  const location = useLocation();
  const history = useHistory();

  const create = useCallback(() => {
    history.push('/@next/cash-flow/operations/create', { background: location });
  }, [history, location]);

  return { selection, resetSelection, create, selectAll, reset, fetch };
};
